<main role="main" class="page-statistiques not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/']" routerLinkActive="router-link-active" >{{"general.Accueil" | translate}}</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)"  [routerLink]="['/services/portnet']" routerLinkActive="router-link-active">{{"general.Service" | translate}}</a></li>
            <li class="breadcrumb-item active">Statistiques National</li>
          </ol>
        </nav>
        <h2>{{bloc.Titre}}</h2>
        <p class="text-primary size18 font-weight-semibold">{{bloc.Contenu}}</p>
      </div>
    </div>
  </div>
  <section class="c-section-full">
    <div class="container">
      <div class="row">
        <div class="col-md-2">

        </div>
        <div class="col-md-4">
          <div class="rounded-block text-center">
            <h3 class="titre3">{{"Statistiques.StatistiqueTrimNational" | translate}}</h3>
            <form class="form-inline" action="" method="get">
              <div class="form-group">
                <select class="form-control StatistiqueSelectMois" id="service"
                  (change)="changetrim(SelectedTrim.value)" name="SelectedTrim" #SelectedTrim
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option *ngFor="let trim of currentTrims" [value]="trim.File?.ServerRelativeUrl" [selected]="i==0">
                    {{"StatistiquesMois."+ trim.Num_x0020_trim | translate}}</option>
                </select>
                <select class="form-control StatistiqueSelectAnnee" (change)="changeYear(SelectedYear)" id="service"
                  name="SelectedYear" [(ngModel)]="SelectedYear"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option *ngFor="let Year of DistinctYear" [Value]="Year" [selected]="i==0">{{Year}}</option>
                </select>
              </div>
            </form><a class="btn btn-info pl-5" id="downloadReportM" (click)="DownloadTarget(UrlStatistiqueTrim)"
              href="javascript:void(0)">
              <span class="icon-download"></span>
                {{"Statistiques.Telecharger" | translate}}</a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="rounded-block text-center">
            <h3 class="titre3">{{"Statistiques.RapportsAnnuels" | translate}}</h3>
            <form class="form-inline" action="" method="get">
              <div class="form-group">
                <select class="form-control StatistiqueSelect"
                  (change)="ChangeStatistiqueAnnuel(SelectedStatistiquesAnnuel)" id="service"
                  name="SelectedStatistiquesAnnuel" [(ngModel)]="SelectedStatistiquesAnnuel"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option *ngFor="let StatistiqusAnnuel of StatistiquesAnnuel ; let index1=index"
                    [ngValue]="StatistiqusAnnuel?.File?.ServerRelativeUrl" [selected]="index1==0">
                    <span>{{StatistiqusAnnuel.annee_x002d_stat_x002d_annuel}}</span>
                  </option>
                </select>
              </div>
            </form><a class="btn btn-info pl-5" id="downloadReportM"
              (click)="DownloadTarget(SelectedStatistiquesAnnuel)" href="javascript:void(0)">
              <span class="icon-download"></span>
              {{"Statistiques.Telecharger" | translate}} </a>
          </div>
        </div>
      </div>
    </div>
  </section>

</main>